export default __webpack_public_path__ + "static/media/list_normal.3f370395.svg";